/**
 * Convert ipfs:// URIs to an HTTP gateway URL (browser-safe for <img src>).
 * @param {string|null|undefined} uri
 * @param {string} [gatewayBase]
 * @returns {string|null}
 */
export function ipfsToGatewayUrl(uri, gatewayBase = "https://gateway.pinata.cloud/ipfs") {
  if (uri == null || typeof uri !== "string") return null;
  const t = uri.trim();
  if (!t) return null;
  if (/^https?:\/\//i.test(t)) return t;
  if (t.startsWith("ipfs://")) {
    const base = String(gatewayBase || "https://gateway.pinata.cloud/ipfs").replace(/\/+$/, "");
    const path = t.slice(7).replace(/^\/+/, "");
    if (!path) return null;
    return `${base}/${path}`;
  }
  return null;
}
